import { render, staticRenderFns } from "./zzItem.vue?vue&type=template&id=cb0bee1a&scoped=true"
import script from "./zzItem.vue?vue&type=script&lang=js"
export * from "./zzItem.vue?vue&type=script&lang=js"
import style0 from "./zzItem.vue?vue&type=style&index=0&id=cb0bee1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0bee1a",
  null
  
)

export default component.exports